<template>
  <v-dialog v-model="dialog.show" max-width="800" persistent>
    <v-card>
      <v-toolbar :color="getAppBarColor" dark>{{ dialog.title }}</v-toolbar>
      <v-card-text>
        <v-row justify="space-around">
          <v-col cols="6">
            <v-card>
              <v-card-title class="elevation-1 pt-1 mt-1 pb-1 mb-1">Empresas Não Vinculadas</v-card-title>
              <v-btn
                class="ma-3 pl-5 pr-5"
                outlined
                color="blue darken-1"
                small
                dark
                rounded
                depressed
                @click="desvincularTodas()"
              >Desvincular Todas</v-btn>
              <v-card-text>
                <draggable
                  v-model="empresasNaoVinculadas"
                  v-bind="dragOptions"
                  @remove="addDefaultNaoVinculados"
                  @add="removeDefaultNaoVinculado"
                >
                  <transition-group type="transition">
                    <v-list-item v-for="empresa in empresasNaoVinculadas" :key="empresa.cnpj">
                      <v-list-item-content>
                        <v-list-item-title v-html="empresa.nome"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </transition-group>
                </draggable>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="6">
            <v-card>
              <v-card-title class="elevation-1 pt-1 mt-1 pb-1 mb-1">Empresas Vinculadas</v-card-title>
              <v-btn
                class="ma-3 pl-5 pr-5"
                outlined
                color="blue darken-1"
                small
                dark
                rounded
                depressed
                @click="vincularTodas()"
              >Vincular Todas</v-btn>
              <v-card-text>
                <draggable
                  v-model="empresasVinculadas"
                  v-bind="dragOptions"
                  @remove="addDefaultVinculados"
                  @add="removeDefaultVinculado"
                >
                  <transition-group type="transition">
                    <v-list-item v-for="empresa in empresasVinculadas" :key="empresa.cnpj">
                      <v-list-item-content>
                        <v-list-item-title v-html="empresa.nome"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </transition-group>
                </draggable>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="blue darken-1"
          small
          dark
          rounded
          depressedclass="ma-3 pl-5 pr-5"
          outlined
          depressed
          @click="save()"
        >Salvar</v-btn>

        <v-btn
          class="ma-3 pl-5 pr-5"
          outlined
          color="red darken-2"
          small
          dark
          rounded
          depressed
          @click="close()"
        >Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import draggable from "vuedraggable";
import Empresa from "@/services/empresa";
import { Scripts } from "@/services/materiais";

export default {
  components: {
    draggable
  },

  data() {
    return {
      dialog: {
        show: false,
        title: ""
      },
      empresasVinculadas: [],
      empresasNaoVinculadas: [],
      empresas: [],
      empresasScript: [],
      script: null
    };
  },

  methods: {
    async show(script) {
      try {
        if (this.empresas.length === 0) {
          await this.getEmpresas();
        }
        this.dialog.title = "Vincular empresas ao script";
        this.script = { ...script };
        this.filterEmpresasVinculadas();
        this.filterEmpresasNaoVinculadas();
        this.dialog.show = true;
        return Promise.resolve();
      } catch (error) {
        return Promise.reject(error);
      }
    },

    filterEmpresasVinculadas() {
      for (const empresa of this.empresas) {
        for (const empresaScript of this.script.empresas) {
          if (empresa.cnpj === empresaScript) {
            this.empresasVinculadas.push(empresa);
          }
        }
      }
      if (this.empresasVinculadas.length === 0) {
        this.empresasVinculadas.push({
          cnpj: 0,
          nome: "Não há empresas vinculadas"
        });
      }
    },

    filterEmpresasNaoVinculadas() {
      for (const empresa of this.empresas) {
        let not_in = true;
        for (const empresaScript of this.script.empresas) {
          if (empresa.cnpj === empresaScript) {
            not_in = false;
          }
        }
        if (not_in) {
          this.empresasNaoVinculadas.push(empresa);
        }
      }
      if (this.empresasNaoVinculadas.length === 0) {
        this.empresasNaoVinculadas.push({
          cnpj: 0,
          nome: "Não há empresas não vinculadas"
        });
      }
    },

    async getEmpresas() {
      try {
        const empresas = await new Empresa().getAll();
        this.empresas = empresas.map(empresa => empresa);
        return Promise.resolve();
      } catch (error) {
        this.$toast.error("Erro ao Buscar Empresas");
        return Promise.reject(error);
      }
    },

    close() {
      this.empresasVinculadas = [];
      this.empresasNaoVinculadas = [];
      this.dialog.show = false;
    },

    async save() {
      try {
        this.removeDefaultVinculado();
        this.empresasScript = this.empresasVinculadas.map(
          empresa => empresa.cnpj
        );

        const resp = await new Scripts().updateEmpresaScript(
          this.script.id,
          this.empresasScript
        );
        this.$emit("updated");
        this.close();
        return Promise.resolve(resp);
      } catch (error) {
        this.$toast.error("Erro ao atualizar dados");
        return Promise.reject(error);
      }
    },

    addDefaultVinculados() {
      if (this.empresasVinculadas.length === 0) {
        this.empresasVinculadas.push({
          cnpj: 0,
          nome: "Não há empresas vinculadas"
        });
      }
    },

    addDefaultNaoVinculados() {
      if (this.empresasNaoVinculadas.length === 0) {
        this.empresasNaoVinculadas.push({
          cnpj: 0,
          nome: "Não há empresas não vinculadas"
        });
      }
    },

    removeDefaultVinculado() {
      let index = this.empresasVinculadas.findIndex(
        empresa => empresa.cnpj === 0
      );
      index !== -1 ? this.empresasVinculadas.splice(index, 1) : null;
    },

    removeDefaultNaoVinculado() {
      const index = this.empresasNaoVinculadas.findIndex(
        empresa => empresa.cnpj === 0
      );
      index !== -1 ? this.empresasNaoVinculadas.splice(index, 1) : null;
    },

    vincularTodas() {
      let empresas = this.empresasNaoVinculadas.filter(
        empresa => empresa.cnpj !== 0
      );
      this.empresasNaoVinculadas = [];
      this.addDefaultNaoVinculados();
      this.removeDefaultVinculado();
      this.empresasVinculadas.push(...empresas);
    },

    desvincularTodas() {
      let empresas = this.empresasVinculadas.filter(
        empresa => empresa.cnpj !== 0
      );
      this.empresasVinculadas = [];
      this.addDefaultVinculados();
      this.removeDefaultNaoVinculado();
      this.empresasNaoVinculadas.push(...empresas);
    }
  },

  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost"
      };
    }
  }
};
</script>

<style scoped>
.ghost {
  opacity: 0.5;
  background: #939499;
}
</style>
